<div class="container navtop">

    <h2 class="col-12 primary-font"><b>Gérer ma recharge</b></h2>



      <!-- spinner -->
  <div *ngIf="wait" class="col-12  spinner">
    <div class="row justify-content-center my-5">
      <mat-spinner class="mt-5" strokeWidth="19" [diameter]="100" color="primary"></mat-spinner>
    </div>
  </div>



    <div class="row justify-content-center mb-5">
        <mat-card *ngIf="stationDetail" class="col-11 col-lg-6 bordure mat-elevation-z8">
            <mat-card-content>


                <h3 class="text-center"><b>Détails de la station</b></h3>

                <h4 class="col-12"><b>{{stationDetail?.name}}</b></h4>



                <h4 class="col-12">{{stationDetail?.street}}, {{stationDetail?.zipcode}}
                    {{stationDetail?.city}}</h4>

                <h4 class="col-12">{{stationDetail?.price.description_price}}</h4>



                <div class="row justify-content-center">

                    <img mat-card-image class="col-6" style="margin-bottom: 0px !important;"
                        [src]="sanitizeImageUrl('data:'+stationDetail?.image.mimetype+';base64,'+stationDetail?.image.file)"
                        alt="clem">


                </div>


            </mat-card-content>
        </mat-card>



    </div>






    <div class="row justify-content-center">
        <mat-card *ngIf="stationDetail"  class="col-11 col-lg-6 bordure mat-elevation-z8">
            <mat-card-content>

                <h2 class="text-center primary-font"><b>Gérer</b></h2>

                <div class="row justify-content-center mb-4">
                    <button class="col-8 col-lg-5" (click)="StartCharge()" mat-raised-button color="primary" type="submit">Lancer la
                        charge</button>
                </div>

                <div class="row justify-content-center mb-4">
                    <button class="col-8 col-lg-5" (click)=" StopCharge()" mat-raised-button color="primary" type="submit">Arrêter la
                        charge</button>
                </div>


                <h5 class="text-center"><b>Assistance technique : 01 86 86 01 49</b></h5>


            </mat-card-content>
        </mat-card>



    </div>





    <h2 *ngIf="!stationDetail" class="text-center">Veuillez  rescanner  le QR code</h2>











</div>